<template>
  <div :class="`flex flex-col items-center justify-center leading-16 ${secondary ? 'bg-alpha-5 text-primary-200' : ''}`">
    <span class="font-bold">{{ abbreviateNumber(count) }}</span>
    <span :class="`text-xxs tracking-widest text-primary-300 ${!secondary ? 'text-primary-300' : ''}`">{{ text }}</span>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { abbreviateNumber } from '~/modules/common/utils/stringUtils';

export default defineComponent({
  props: {
    count: {
      type: Number | String,
      default: 0,
    },
    text: {
      type: String,
      default: 'TEXT',
    },
    secondary: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return { abbreviateNumber };
  },
});
</script>
